export function clampSmaWindow(n: unknown): number | null {
    if (typeof n !== "number" || !Number.isFinite(n)) return null;
    const rounded = Math.floor(n);
    if (rounded <= 1) return null;
    // Guardrail: avoid absurdly large windows freezing the UI
    return Math.min(rounded, 1000);
}

export function simpleMovingAverage(values: number[], windowSize: number): Array<number | null> {
    if (windowSize <= 1) {
        return values;
    }
    const out: Array<number | null> = new Array(values.length).fill(null);
    let sum = 0;
    for (let i = 0; i < values.length; i++) {
        sum += values[i];
        if (i >= windowSize) {
            sum -= values[i - windowSize];
        }
        if (i >= windowSize - 1) {
            out[i] = sum / windowSize;
        }
    }
    return out;
}
